import React, { MouseEvent } from 'react';
import { PrimaryButton } from '../../../components/Button';
import * as EmptyMessageUI from './EmptyMessageUI';

interface IProps {
  title: string;
  tip: string;
  imageUrl: string;
  buttonLabel: string;
  onButtonClick: () => void;
  actionDisabled?: boolean;
}

const EmptyMessage = ({
  title,
  tip,
  imageUrl,
  buttonLabel,
  onButtonClick,
  actionDisabled,
}: IProps) => {
  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onButtonClick();
  };

  return (
    <EmptyMessageUI.Container>
      <EmptyMessageUI.StyledImage src={imageUrl} wrapped />
      <EmptyMessageUI.Title>{title}</EmptyMessageUI.Title>
      <EmptyMessageUI.Tip>{tip}</EmptyMessageUI.Tip>
      <PrimaryButton
        type="button"
        onClick={handleButtonClick}
        disabled={actionDisabled}
      >
        {buttonLabel}
      </PrimaryButton>
    </EmptyMessageUI.Container>
  );
};

export default EmptyMessage;
